import { TableCell, TableRow, Theme, withStyles } from '@material-ui/core';
import React, { memo } from 'react';
import { getValueByPropName } from '../../utils/helpers';
import { isDarkTheme } from '../../eliot-components/src/theme';

export const StyledTableRow = withStyles((theme: Theme) => ({
  root: {
    '&.clickable': {
      cursor: 'pointer',
    },
    '&.pinned': {
      backgroundColor: isDarkTheme(theme)
        ? theme.palette.primary.dark
        : theme.palette.primary.light + ' !important',
    },
    '& td': {
      padding: theme.spacing(0, 1),
      '&.noPadding': {
        padding: '0px 0px',
      },
    },
    '& th': {
      padding: theme.spacing(0, 1),
      '&.noPadding': {
        padding: '0px 0px',
      },
    },
  },
}))(TableRow);

export const InfiniteTableRow = memo(
  ({
    entity,
    tableColumns,
    getKeyValue,
    onRowClick,
    onDoubleClick,
  }: {
    entity: any;
    tableColumns: any[];
    getKeyValue: (entity: any) => string;
    onRowClick?: (entity: any) => void;
    onDoubleClick?: (txt: string) => void;
  }) => (
    <StyledTableRow
      className={`${onRowClick ? 'clickable' : ''} ${
        entity.isPinned ? 'pinned' : ''
      }`}
      key={getKeyValue(entity)}
      onClick={(e) => {
        if (
          onRowClick &&
          e.target &&
          //@ts-ignore
          e.target.tagName !== undefined &&
          //@ts-ignore
          ['td', 'i'].indexOf(e.target.tagName.toLowerCase()) > -1
        ) {
          const selection = window.getSelection();
          const selectedText = selection ? selection.toString() : '';
          e.preventDefault();
          if (selectedText && onDoubleClick) {
            onDoubleClick(selectedText);
          } else {
            onRowClick(entity);
          }
        }
      }}
    >
      {tableColumns.map((column) => (
        <TableCell
          className={column.noPadding ? 'noPadding' : ''}
          key={getKeyValue(entity) + column.name}
        >
          {!!column.cell
            ? column.cell(entity)
            : getValueByPropName(entity, column.name)}
        </TableCell>
      ))}
    </StyledTableRow>
  ),
  (prevProps, nextProps) => {
    if (
      prevProps.entity === nextProps.entity &&
      prevProps.tableColumns === nextProps.tableColumns
    ) {
      return true; // Component will use cached value and not re-render
    }
    return false; // Component will re-render
  }
);
